export enum AnalysisType {
  ALL = 1,
  CHART,
}

export enum AnalysisState {
  DISCONNECTED = 1,
  IN_PROGRESS = 2,
  OK = 3,
}

export enum ANLAYSIS_QUESTION_TYPE {
  SUMMARY = 1,
  QUESTION = 2,
}
